import { defineStore } from 'pinia';
import OnixKnowledgeAPI from 'dashboard/api/onix/knowledge';

export const useOnixKnowledgeStore = defineStore('onixKnowledge', {
  state: () => ({
    collections: [],
    current: null,
    entries: [],
    retrieveResults: [],
    uiFlags: {
      fetchingList: false,
      fetchingItem: false,
      creatingItem: false,
      creatingChunk: false,
      retrieving: false,
    },
  }),

  getters: {
    getCollections: state => state.collections,
    getCurrent: state => state.current,
    getEntries: state => state.entries,
    getRetrieveResults: state => state.retrieveResults,
    getUIFlags: state => state.uiFlags,
  },

  actions: {
    setUIFlag(data) {
      this.uiFlags = { ...this.uiFlags, ...data };
    },

    async fetch() {
      this.setUIFlag({ fetchingList: true });
      try {
        const { data } = await OnixKnowledgeAPI.get();
        this.collections = data.payload || [];
      } catch {
        this.collections = [];
      } finally {
        this.setUIFlag({ fetchingList: false });
      }
    },

    async fetchOne(id) {
      this.setUIFlag({ fetchingItem: true });
      if (this.current?.id !== Number(id)) {
        this.current = null;
        this.entries = [];
      }
      this.retrieveResults = [];
      try {
        const { data } = await OnixKnowledgeAPI.show(id);
        this.current = data;
        this.entries = data.entries || [];
        return data;
      } catch {
        this.current = null;
        this.entries = [];
        return null;
      } finally {
        this.setUIFlag({ fetchingItem: false });
      }
    },

    async create(payload) {
      this.setUIFlag({ creatingItem: true });
      try {
        const { data } = await OnixKnowledgeAPI.create(payload);
        this.collections = [data, ...this.collections];
        return data;
      } catch {
        return null;
      } finally {
        this.setUIFlag({ creatingItem: false });
      }
    },

    async createChunk(payload) {
      this.setUIFlag({ creatingChunk: true });
      try {
        const { data } = await OnixKnowledgeAPI.createChunk(payload);
        return data;
      } catch {
        return null;
      } finally {
        this.setUIFlag({ creatingChunk: false });
      }
    },

    async retrieveTest({ collectionId, query, topK }) {
      this.setUIFlag({ retrieving: true });
      try {
        const { data } = await OnixKnowledgeAPI.retrieveTest({
          collectionId,
          query,
          topK,
        });
        this.retrieveResults = data.payload || [];
        return this.retrieveResults;
      } catch {
        this.retrieveResults = [];
        return null;
      } finally {
        this.setUIFlag({ retrieving: false });
      }
    },
  },
});
